<div class="flex-start status-container {{this.selectedType}}">
    <div class="round-indicator {{this.selectedType}}"></div>
    <div>{{ this.selected }}</div>
</div>
